import React, {useState} from 'react';
import addeparLogo from '../../assets/images/connect-logos/addepar.png';
import billLogo from '../../assets/images/connect-logos/bill.png';
import charlesSchwabLogo from '../../assets/images/connect-logos/charles-schwab.png';
import northernTrustLogo from '../../assets/images/connect-logos/northern-trust.png';
import pershingLogo from '../../assets/images/connect-logos/pershing.png';
import plaidLogo from '../../assets/images/connect-logos/plaid.png';
import rampLogo from '../../assets/images/connect-logos/ramp.png';
import {BillModal} from '../../components/Navbar/BillModal';
import {BridgeFTLinkModal} from '../../components/Navbar/BridgeFTModal';
import {PlaidLinkContent} from '../../components/Plaid/PlaidLinker';
import {useAuth} from '../../hooks/use-auth';
import '../../styles/plaid.css';

const ADDEPAR_OAUTH_URL =
  'https://forestsystems.clientdev.addepar.com/oauth2/authorize?response_type=code&scope=entities+portfolio+profile+transactions+transactions_write&client_id=forestsys_dev&redirect_uri=https%3A%2F%2Fforest-systems-plaid-dev.web.app%2FaddeparConnect';

const ConnectionCard = ({logoSrc, logoAlt, description, onClick, disabled}) => (
  <div
    className={`connection-card${disabled ? ' connection-card-disabled' : ''}`}
    onClick={disabled ? undefined : onClick}
  >
    <div className='connection-card-logo'>
      <img src={logoSrc} alt={logoAlt} />
      {disabled && (
        <div className='connection-card-coming-soon'>Coming soon</div>
      )}
    </div>
    <div className='connection-card-description'>{description}</div>
  </div>
);

const SectionHeader = ({title}) => (
  <div className='connection-section-header'>{title}</div>
);

export default function AddConnectionPage({user}) {
  const {
    state: {client},
  } = useAuth();

  const [plaidActive, setPlaidActive] = useState(false);
  const [billActive, setBillActive] = useState(false);
  const [bridgeActive, setBridgeActive] = useState(false);

  const openAddepar = () => {
    window.location.href = ADDEPAR_OAUTH_URL;
  };

  const showPlaid = !!client?.plaid;
  const showBill = !!client?.bill;
  const showBridge = !!client?.bridgeft;
  const showAddepar = !!client?.addepar;

  return (
    <div className='page-container'>
      {showPlaid && (
        <>
          <SectionHeader title='Connect Bank Accounts' />
          <div className='connection-card-grid'>
            <ConnectionCard
              logoSrc={plaidLogo}
              logoAlt='Plaid'
              description={
                <>
                  Click on the logo to connect a bank account with{' '}
                  <strong>Plaid</strong>.<br />
                  <br />
                  Use your online banking credentials to access your banking
                  transactions through Forest Connect and Plaid.
                </>
              }
              onClick={() => setPlaidActive(true)}
            />
          </div>
        </>
      )}

      {(showPlaid || showBridge) && (
        <>
          <SectionHeader title='Connect Custodian Accounts' />
          <div className='connection-card-grid'>
            {showPlaid && (
              <ConnectionCard
                logoSrc={plaidLogo}
                logoAlt='Plaid'
                description={
                  <>
                    Click on the logo to connect a custodian account with{' '}
                    <strong>Plaid</strong>.<br />
                    <br />
                    Use your online banking credentials to access your
                    investment transactions through Forest Connect and Plaid.
                    Note, Transaction Types are limited.
                  </>
                }
                onClick={() => setPlaidActive(true)}
              />
            )}
            {showBridge && (
              <ConnectionCard
                logoSrc={northernTrustLogo}
                logoAlt='Northern Trust'
                description={
                  <>
                    Click on the logo to connect a custodian account from{' '}
                    <strong>Northern Trust</strong>.<br />
                    <br />
                    Receive account transactions and security pricing
                    information. Available in FTP only.
                  </>
                }
                onClick={() => setBridgeActive(true)}
              />
            )}
            <ConnectionCard
              logoSrc={pershingLogo}
              logoAlt='Pershing'
              description={
                <>
                  Click on the logo to connect a custodian account from{' '}
                  <strong>Pershing</strong>.<br />
                  <br />
                  Receive account transactions and security pricing
                  information.
                </>
              }
              disabled
            />
            <ConnectionCard
              logoSrc={charlesSchwabLogo}
              logoAlt='Charles Schwab'
              description={
                <>
                  Click on the logo to connect a custodian account from{' '}
                  <strong>Charles Schwab</strong>.<br />
                  <br />
                  Receive account transactions and security pricing
                  information.
                </>
              }
              disabled
            />
          </div>
        </>
      )}

      {showBill && (
        <>
          <SectionHeader title='Connect Bill Pay Software' />
          <div className='connection-card-grid'>
            <ConnectionCard
              logoSrc={billLogo}
              logoAlt='BILL'
              description={
                <>
                  Click on the logo to connect your Forest database with{' '}
                  <strong>BILL</strong>.<br />
                  <br />
                  Receive bill pay and credit card transaction already in
                  double-entry accounting format.
                </>
              }
              onClick={() => setBillActive(true)}
            />
            <ConnectionCard
              logoSrc={rampLogo}
              logoAlt='Ramp'
              description={
                <>
                  Click on the logo to connect your Forest database with{' '}
                  <strong>Ramp</strong>.<br />
                  <br />
                  Receive bill pay and credit card transaction already in
                  double-entry accounting format.
                </>
              }
              disabled
            />
          </div>
        </>
      )}

      {showAddepar && (
        <>
          <SectionHeader title='Connect Investment Software' />
          <div className='connection-card-grid'>
            <ConnectionCard
              logoSrc={addeparLogo}
              logoAlt='Addepar'
              description={
                <>
                  Click on the logo to connect your Forest database with{' '}
                  <strong>Addepar</strong>.<br />
                  <br />
                  Send and received transactions between Addepar and Forest.
                </>
              }
              onClick={openAddepar}
            />
          </div>
        </>
      )}

      {plaidActive && (
        <PlaidLinkContent
          active={plaidActive}
          setActive={setPlaidActive}
          user={user}
        />
      )}
      {billActive && <BillModal active={billActive} setActive={setBillActive} />}
      {bridgeActive && (
        <BridgeFTLinkModal active={bridgeActive} setActive={setBridgeActive} />
      )}
    </div>
  );
}
